import React from "react";
import "../../../AllComponentCSS.css";

export default function JS_Home() {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">📘 JavaScript Tutorial</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        JavaScript (JS) is the most popular programming language for web
        development. It allows you to create interactive, dynamic, and
        responsive websites. This tutorial covers everything from basics to
        advanced topics with examples.
      </p>

      {/* Key Points */}
      <div
        style={{
          background: "linear-gradient(135deg, #f0f9ff, #e0f2fe)",
          padding: "1rem",
          paddingLeft: "35px",
          borderRadius: "12px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#075985" }}>🔑 What You'll Learn</h2>
        <ul className="tutorial-list-points">
          <li>JavaScript basics: syntax, variables, data types</li>
          <li>Functions, loops, and conditionals</li>
          <li>DOM manipulation and events</li>
          <li>ES6+ features (let, const, arrow functions, promises)</li>
          <li>Advanced topics: async/await, fetch API, modules</li>
          <li>Practical projects to apply your skills</li>
        </ul>
      </div>

      {/* Why Learn JS */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Why Learn JavaScript?</h2>
        <p>
          JavaScript is the backbone of modern web development. Whether you’re
          building websites, mobile apps, or server-side applications,
          JavaScript is everywhere. Frameworks like React, Angular, and Vue make
          it even more powerful.
        </p>
      </div>

      {/* Example */}
      <div className="tutorial-section">
        <h2 className="section-title">⚡ Quick Example</h2>
        <p>
          Here’s a simple JavaScript example that shows an alert when you click
          a button:
        </p>

        <pre className="tutorial-code">
          {`<!DOCTYPE html>
<html>
  <head>
    <title>JS Example</title>
  </head>
  <body>
    <button onclick="showMessage()">Click Me</button>

    <script>
      function showMessage() {
        alert("Hello, JavaScript!");
      }
    </script>
  </body>
</html>`}
        </pre>

        <div style={{ marginTop: "1rem" }}>
          <button
            onClick={() => alert("Hello, JavaScript!")}
            style={{
              padding: "10px 20px",
              background: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Try Me
          </button>
        </div>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef9c3, #fde68a)",
          padding: "1rem",
          paddingLeft: "35px",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#92400e" }}>📌 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Start with <b>JavaScript Basics</b>
          </li>
          <li>Practice small coding exercises</li>
          <li>
            Learn how to interact with the <b>DOM</b>
          </li>
          <li>Explore ES6+ features and modern syntax</li>
          <li>Build mini projects to reinforce your knowledge</li>
        </ul>
      </div>
    </div>
  );
}
